
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

window.Vue.mixin({
  methods: {
    escapeHtml(unsafe) {
      return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    },
  },
});

window.bus = new Vue();

window.guid = function() {
  var S4 = function() {
    return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
  };
  return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
};

window.backend = (function (options) {
  const client = require('./helpers/BackendClient').default;
  return new client(options);
})(window.backendOptions || {});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

if (document.getElementById('clock')) {
  new Vue({
    el: "#clock",
    components: {
      'clock': require('./components/Clock'),
    },
  });
}

// Blur (remove focues state) from clicked buttons to avoid dummy persistent focus effect
if (typeof window.jQuery === 'function') {
  (function ($) {
    $(function() {
      // bind event handler to body with event-scoped selector to handle targets
      // added dynamically to dom
      $('body').on('mouseup', '.btn, .page-item', function(ev) {
        ev.target.blur();
      });
    });
  })(window.jQuery);
}

window.datetimePickerConfig = function(overwrites) {
  return Object.assign({
      locale: 'en',
      format: 'YYYY-MM-DD HH:mm:ss',
      viewMode: 'years',
      useCurrent: false,
      showTodayButton: true,
      showClear: true,
  }, overwrites || {});
};



// WEBPACK FOOTER //
// ./resources/assets/js/app.js